import React from "react";
import { useSelector } from "react-redux";

function Backend() {
  const es_en = useSelector((state) => state.translation);
  return (
    <div className="skills__content">
      <h3 className="skills__title">{es_en ? "Back-end" : "Back-end"}</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="nodejs" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Node.js</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="badge-check" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Express</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="postgresql" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">PostresSQL</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="mongodb" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">MongoDB</h3>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="badge-check" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Nest.js</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="data" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">SQL</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="brain" type="solid" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">REST</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="badge-check" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">TypeORM</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Backend;
